<template>
    <v-container>

        <v-snackbar v-model="snackbar" :color="snackbarColor" :top="true" :right="true" :timeout="6000">

            {{ message }}

            <v-btn dark text @click="snackbar = false">

                CLOSE

            </v-btn>

        </v-snackbar>

        <v-row>

            <v-col cols="12" md="4">

                <p class="white--text tdate"> {{ todaysDate }} </p>

            </v-col>
            <v-flex xs2 style="padding: 3px" v-if="displayTimerEslip">
                <v-card raised height="130px" class="card"
                        >
                  <v-card-text class="text-center">
                    <p class="cardtext primary--text"> Eslip Timer </p>
                    <a href="/cleancoffee" class="cardlink"> {{ daysEslip }} Days {{ hoursEslip }} Hrs {{ minutesEslip }} Mins {{ secondsEslip  }} Seconds Remaining for saleNo {{ saleNo }} Sale Date {{ saleDate }} </a>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex xs2 style="padding: 3px" v-if="displayInvoice">
                <v-card raised height="130px" class="card"
                        >
                  <v-card-text class="text-center">
                    <p class="cardtext primary--text"> {{ invoicemessage }} </p>
                  </v-card-text>
                </v-card>
              </v-flex>
            <v-col cols="12" md="6">

                <countdown v-if="deadline" :deadline="deadline" :speed="1000"></countdown>

            </v-col>

 </v-row>
 <v-layout row wrap ml-3>
  
      <v-flex xs2 style="padding: 3px"  v-if="displayTimerDispatch">
        <v-card raised height="155px" class="card" v-if="displayTimerDispatch">
          <v-card-text class="text-center">
            <span class="accentd--text cardtext"> Dispatch Timer </span>
            <p class="accentd--text cardtext">  {{ daysDispatch }} Days {{ hoursDispatch }} Hrs {{ minutesDispatch }} Mins {{ secondsDispatch  }} Seconds Remaining for saleNo {{ saleNo }} Sale Date {{ saleDate }}  </p>

          </v-card-text>
        </v-card>
      </v-flex>
   
      <v-flex xs2 style="padding: 3px" v-if="displayTimerCatalogue">
        <v-card raised height="155px" class="card" v-if="displayTimerCatalogue">
          <v-card-text class="text-center">
              <span class="accentd--text cardtext"> Catalogue Timer </span>
              <p class="accentd--text cardtext">  {{ daysCatalogue }} Days {{ hoursCatalogue }} Hrs {{ minutesCatalogue }} Mins {{ secondsCatalogue  }} Seconds Remaining for saleNo {{ saleNo }} Sale Date {{ saleDate }}   </p>
            </v-card-text>
        </v-card>
      </v-flex>
    
</v-layout>
 <v-layout row wrap ml-3>
  <v-flex xs2>
    <v-card raised height="130px" class="card" @click="uploadedCataloguesTab"
    :class="uploadedCatalogues === true ? 'activecard' : ''">
      <v-card-text class="text-center">
          <span class="cardnumber accentd--text"> {{ noOfCatalogues }} </span>
          <p class="accentd--text cardtext"> Uploaded Catalogues </p>
          <router-link to="/catalogue" class="cardlink">Upload More</router-link>
      </v-card-text>
    </v-card>
  </v-flex>
  <v-flex xs2 offset-xs1>
    <v-card raised height="130px" class="card" @click="confirmedInvoicesTab"
    :class="confirmedInvoices === true ? 'activecard' : ''">
      <v-card-text class="text-center">
          <span class="cardnumber accentd--text"> {{ noOfConfirmedInvoices }} </span>
          <p class="cardtext accentd--text"> Confirmed Invoices </p>
          <router-link v-if="hasPerm('CAN_VERIFY_INVOICE')" to="/invoice/generated" class="cardlink">Confirm More({{unconfirmedInvoices}})</router-link>
      </v-card-text>
    </v-card>
  </v-flex>
  <v-flex xs6 offset-xs1>
    <v-card class="invoicescard">
      <canvas id="myChart" width="600" height="150"></canvas>
    </v-card>
  </v-flex>
</v-layout>
<v-layout mt-3>
  <v-flex xs12 mt-3>
    <catalogues-dash v-show="uploadedCatalogues"></catalogues-dash>
    <invoices-dash v-show="confirmedInvoices"></invoices-dash>
  </v-flex>
</v-layout>

<v-dialog v-model="dialog" persistent max-width="500">
<v-card>
  <v-card-title class="headline accent--text">Upload Catalogue</v-card-title>
  <v-card-text>
    <v-form ref="form" v-model="valid" lazy-validation>
      <label>File
       <input type="file" id="file" ref="file" v-on:change="handleFileUpload()" required/>
     </label>
    </v-form>
  </v-card-text>
  <v-card-actions>
    <v-btn color="primary"  @click="dialog = false">Cancel</v-btn>
    <v-spacer></v-spacer>
    <v-btn color="secondary"
                class="accent--text logoutbtn"  @click="uploadCatalogue">Upload</v-btn>
  </v-card-actions>
</v-card>
</v-dialog>

</v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import Chart from 'chart.js'
import InvoicesDash from './InvoicesDash'
import CataloguesDash from './CataloguesDash'
import Countdown from '../views/auction/Countdown'
import axios from 'axios'
import config from '../../config'

export default {
	name: 'MarketerDash',
	components: {
		InvoicesDash,
		CataloguesDash,
		Countdown
	},
	data: function () {
		return {
			uploadedCatalogues: true,
			confirmedInvoices: false,
			dialog: false,
			message: '',
			snackbar: false,
			snackbarColor: '',
			valid: true,
			noOfCatalogues: 0,
			noOfConfirmedInvoices: 0,
			unconfirmedInvoices: 0,
			invoicesChart: {},
			remainingTimeParchment: 0,
			remainingTimeDispatch: 0,
			remainingTimeCleanCoffee: 0,
			remainingTimeCatalogue: 0,
			remainingTimeAuction: 0,
			targetDateParchment: 0,
			targetDateDispatch: 0,
			targetDateCleanCoffee: 0,
			targetDateCatalogue: 0,
			targetDateAuction: 0,
			displayTimerParchment: true,
			displayTimerDispatch: true,
			displayTimerCleanCoffee: true,
			displayTimerCatalogue: true,
			displayTimerAuction: true,
			interval: null,
			days: 0,
			hours: 0,
			minutes: 0,
			seconds: 0,
			daysEslip: 0,
			hoursEslip: 0,
			minutesEslip: 0,
			secondsEslip: 0,
			daysParchment: 0,
			hoursParchment: 0,
			minutesParchment: 0,
			secondsParchment: 0,
			daysDispatch: 0,
			hoursDispatch: 0,
			minutesDispatch: 0,
			secondsDispatch: 0,
			daysCleanCoffee: 0,
			hoursCleanCoffee: 0,
			minutesCleanCoffee: 0,
			secondsCleanCoffee: 0,
			daysCatalogue: 0,
			hoursCatalogue: 0,
			minutesCatalogue: 0,
			secondsCatalogue: 0,
			daysAuction: 0,
			hoursAuction: 0,
			minutesAuction: 0,
			secondsAcution: 0,
			isDashboard: false,
			saleNo: '',
			saleDate: '',
			displayInvoice: false,
			invoicemessage: '',
			displayTimerEslip: false,
			targetDateEslip: '',
			items: [{ name: 'catalogue', title: 'Catalogue File', ext: 'xlsx' }, { name: 'dispatch', title: 'Dispatch File', ext: 'xlsx' }],
			deadline: ''
		}
	},
	watch: {
		invoicesChart: function () {
			this.initChart()
		}
	},
	async mounted () {
		this.startCountdown()
		await this.getUpcomingDate()
		this.triggerGetNCETimeline()
		this.getUploadedCatalogues()
		this.getConfirmedInvoices()
		this.getUnConfirmedInvoices()
		this.getChartData()
	},
	computed: {
		...mapState([
			'userInfo', 'user'
		]),
		...mapActions({
			getNceTimeline: 'auction/getNceTimeline'
		}),
		todaysDate: function () {
			const now = new Date()
			const options = {
				day: 'numeric',
				month: 'short',
				weekday: 'long',
				year: 'numeric'
			}
			return now.toLocaleString('en-us', options)
		},
		canConfirmInvoice: function () {
			return this.hasPerm('CAN_VERIFY_INVOICE')
		}
	},
	methods: {
		hasPerm (permission) {
			return this.user.roleId.permissions.includes(permission)
		},
		triggerGetNCETimeline () {
			this.getNceTimeline.then(response => {
				this.deadline = response.data
			}).catch(error => {
				console.log(error.response)
			})
		},
		getUploadedCatalogues () {
			const url = config.serverURI + '/dash/marketer/pending-catalogues'
			axios.get(url)
				.then(response => {
					if (response.status !== 200) {
						this.error = response.statusText
						console.log('Error is ' + this.error)
						return
					}
					this.noOfCatalogues = response.data
				})
				.catch(error => {
					console.log('error', error)
				})
		},
		getConfirmedInvoices () {
			const url = config.serverURI + '/dash/marketer/approved-invoices'
			axios.get(url)
				.then(response => {
					if (response.status !== 200) {
						this.error = response.statusText
						console.log('Error is ' + this.error)
						return
					}
					this.noOfConfirmedInvoices = response.data
				})
				.catch(error => {
					console.log('error', error)
				})
		},
		getUnConfirmedInvoices () {
			const url = config.serverURI + '/dash/marketer/pending-invoices'
			axios.get(url)
				.then(response => {
					if (response.status !== 200) {
						this.error = response.statusText
						console.log('Error is ' + this.error)
						return
					}
					this.unconfirmedInvoices = response.data
				})
				.catch(error => {
					console.log('error', error)
				})
		},
		getChartData () {
			const url = config.serverURI + '/dash/marketer/invoice-chart'
			axios.get(url)
				.then(response => {
					if (response.status !== 200) {
						this.error = response.statusText
						console.log('Error is ' + this.error)
						return
					}
					this.invoicesChart = response.data
				})
				.catch(error => {
					console.log('error', error)
				})
		},
		uploadCatalogueDialog () {
			this.dialog = true
		},
		handleFileUpload () {
			this.file = this.$refs.file.files[0]
		},
		uploadCatalogue () {
			if (this.$refs.form.validate()) {
				const url = config.serverURI + '/upload/catalogue/'
				const formData = new FormData()
				formData.append('file', this.file)
				axios.post(url, formData)
					.then(response => {
						this.dialog = false
						if (response.data.error !== false) {
							this.message = response.data.message
							this.snackbar = true
							this.snackbarColor = 'error'
							return
						}
						this.handleFileUpload()
						this.message = response.data.message
						this.snackbar = true
						this.snackbarColor = 'primary'
					})
					.catch(error => {
						console.log('error', error.response)
						this.message = typeof error.response.data.message !== 'undefined' ? error.response.data.message : error.response.status
						this.snackbar = true
						this.snackbarColor = 'error'
						this.dialog = false
					})
			}
		},
		uploadedCataloguesTab () {
			this.uploadedCatalogues = true
			this.confirmedInvoices = false
		},
		confirmedInvoicesTab () {
			this.uploadedCatalogues = false
			this.confirmedInvoices = true
		},
		initChart () {
			const labels = this.invoicesChart.months
			const data = this.invoicesChart.values
			var ctx = document.getElementById('myChart').getContext('2d')
			Chart.defaults.global.defaultFontStyle = 'bold'
			// eslint-disable-next-line
            new Chart(ctx, {
				type: 'line',
				data: {
					labels: labels,
					datasets: [{
						data: data,
						borderColor: '#162614',
						fill: false,
						borderWidth: 4,
						pointRadius: 0
					}]
				},
				options: {
					title: {
						display: true,
						text: 'Value of invoices for 2019',
						position: 'top',
						fontColor: '#162614'
					},
					legend: {
						display: false
					},
					tooltips: {
						callbacks: {
							label: function (tooltipItem) {
								return tooltipItem.yLabel
							}
						}
					},
					scales: {
						yAxes: [{
							ticks: {
								fontColor: '#1f5b41'
							}
						}],
						xAxes: [{
							ticks: {
								fontColor: '#1f5b41'
							}
						}]
					}
				}
			})
		},
		download (file) {
			const url = config.serverURI + '/files/download?filename=' + file.name
			axios({ url: url, method: 'GET', responseType: 'blob' })
				.then(response => {
					const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/vnd.ms-excel' }))
					const link = document.createElement('a')
					link.href = url
					const itemFileName = file.name + '_001_2020_2021.' + file.ext
					link.setAttribute('download', itemFileName)
					document.body.appendChild(link)
					link.click()
				})
				.catch(error => {
					console.log('error', error.response)
					this.message = 'Error occurred'
					this.snackbar = true
					this.snackbarColor = 'error'
				})
		},
		startCountdown () {
			this.interval = setInterval(this.updateParchmentCountdown, 1000)
			this.interval = setInterval(this.updateDispatchCountdown, 1000)
			this.interval = setInterval(this.updateCleanCoffeeCountdown, 1000)
			this.interval = setInterval(this.updateCatalogueCountdown, 1000)
			this.interval = setInterval(this.updateAuctionCountdown, 1000)
		},
		updateParchmentCountdown () {
			const now = new Date().getTime()
			// this.displayTimerParchment = (this.targetDateParchment === 0) ? false : true

			const distanceParchment = this.targetDateParchment - now
			if (distanceParchment < 0) {
				clearInterval(this.interval)
				// this.isUploadDisabled = true;
				this.daysParchment = 0
				this.hoursParchment = 0
				this.minutesParchment = 0
				this.secondsParchment = 0
				return
			}
			this.daysParchment = Math.floor(distanceParchment / (1000 * 60 * 60 * 24))
			this.hoursParchment = Math.floor((distanceParchment % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
			this.minutesParchment = Math.floor((distanceParchment % (1000 * 60 * 60)) / (1000 * 60))
			this.secondsParchment = Math.floor((distanceParchment % (1000 * 60)) / 1000)
		},
		updateDispatchCountdown () {
			const now = new Date().getTime()
			// this.displayTimerDispatch = (this.targetDateDispatch === 0) ? false : true

			const distanceDispatch = this.targetDateDispatch - now
			if (distanceDispatch < 0) {
				this.daysDispatch = 0
				this.hoursDispatch = 0
				this.minutesDispatch = 0
				this.secondsDispatch = 0
				return
			}
			this.daysDispatch = Math.floor(distanceDispatch / (1000 * 60 * 60 * 24))
			this.hoursDispatch = Math.floor((distanceDispatch % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
			this.minutesDispatch = Math.floor((distanceDispatch % (1000 * 60 * 60)) / (1000 * 60))
			this.secondsDispatch = Math.floor((distanceDispatch % (1000 * 60)) / 1000)
		},
		updateCleanCoffeeCountdown () {
			const now = new Date().getTime()
			// this.displayTimerCleanCoffee = (this.targetDateCleanCoffee === 0) ? false : true

			const distanceCleanCoffee = this.targetDateCleanCoffee - now
			if (distanceCleanCoffee < 0) {
				this.daysCleanCoffee = 0
				this.hoursCleanCoffee = 0
				this.minutesCleanCoffee = 0
				this.secondsCleanCoffee = 0
				return
			}
			this.daysCleanCoffee = Math.floor(distanceCleanCoffee / (1000 * 60 * 60 * 24))
			this.hoursCleanCoffee = Math.floor((distanceCleanCoffee % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
			this.minutesCleanCoffee = Math.floor((distanceCleanCoffee % (1000 * 60 * 60)) / (1000 * 60))
			this.secondsCleanCoffee = Math.floor((distanceCleanCoffee % (1000 * 60)) / 1000)
		},
		updateCatalogueCountdown () {
			const now = new Date().getTime()
			// this.displayTimerCatalogue = (this.targetDateCatalogue === 0) ? false : true

			const distanceCatalogue = this.targetDateCatalogue - now
			if (distanceCatalogue < 0) {
				this.daysCatalogue = 0
				this.hoursCatalogue = 0
				this.minutesCatalogue = 0
				this.secondsCatalogue = 0
				return
			}
			this.daysCatalogue = Math.floor(distanceCatalogue / (1000 * 60 * 60 * 24))
			this.hoursCatalogue = Math.floor((distanceCatalogue % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
			this.minutesCatalogue = Math.floor((distanceCatalogue % (1000 * 60 * 60)) / (1000 * 60))
			this.secondsCatalogue = Math.floor((distanceCatalogue % (1000 * 60)) / 1000)
		},
		updateAuctionCountdown () {
			const now = new Date().getTime()
			this.displayTimerAuction = this.targetDateAuction !== 0
			console.log('target Date Auction:  ' + this.targetDateAuction)
			const distanceAuction = this.targetDateAuction - now
			if (distanceAuction < 0) {
				this.daysAuction = 0
				this.hoursAuction = 0
				this.minutesAuction = 0
				this.secondsAcution = 0
				return
			}
			this.daysAuction = Math.floor(distanceAuction / (1000 * 60 * 60 * 24))
			this.hoursAuction = Math.floor((distanceAuction % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
			this.minutesAuction = Math.floor((distanceAuction % (1000 * 60 * 60)) / (1000 * 60))
			this.secondsAcution = Math.floor((distanceAuction % (1000 * 60)) / 1000)
		},
		async getUpcomingDate () {
			const token = localStorage.getItem('token')
			const tokenconfig = { headers: { Authorization: `Bearer ${token}` } }
			const patchUpcomingDate = config.serverURI + '/timer/upcomingdatewh/PARCHMENT'
			const dispatchUpcomingDate = config.serverURI + '/timer/upcomingdatewh/GRN'
			const cleanCoffeeUpcomingDate = config.serverURI + '/timer/upcomingdatewh/CLEAN-COFFEE'
			const catalogueUpcomingDate = config.serverURI + '/timer/upcomingdatewh/CATALOGUE'
			const auctionUpcomingDate = config.serverURI + '/timer/upcomingdatewh/AUCTION'

			const patchmentReq = axios.get(patchUpcomingDate, { tokenconfig })
			const dispatchReq = axios.get(dispatchUpcomingDate, { tokenconfig })
			const cleancoffeeReq = axios.get(cleanCoffeeUpcomingDate, { tokenconfig })
			const catalogueReq = axios.get(catalogueUpcomingDate, { tokenconfig })
			const auctionReq = axios.get(auctionUpcomingDate, { tokenconfig })

			await axios
				.all([patchmentReq, dispatchReq, cleancoffeeReq, catalogueReq, auctionReq])
				.then(
					axios.spread((...responses) => {
						const patchmentResponse = responses[0]
						const dispatchResponse = responses[1]
						const cleancoffeeResponse = responses[2]
						const catalogueResponse = responses[3]
						const auctionResponse = responses[4]

						this.targetDateParchment = patchmentResponse.data.timeInMillis
						// this.targetDateParchment = new Date().getTime() + parseInt(this.remainingTimeParchment) * 60 * 1000
						this.targetDateDispatch = dispatchResponse.data.timeInMillis
						// this.targetDateDispatch = new Date().getTime() + parseInt(this.remainingTimeDispatch) * 60 * 1000

						this.targetDateCleanCoffee = cleancoffeeResponse.data.timeInMillis
						// this.targetDateCleanCoffee = new Date().getTime() + parseInt(this.remainingTimeCleanCoffee) * 60 * 1000

						this.targetDateCatalogue = catalogueResponse.data.timeInMillis
						// this.targetDateCatalogue = new Date().getTime() + parseInt(this.remainingTimeCatalogue) * 60 * 1000

						this.targetDateAuction = auctionResponse.data.timeInMillis
						this.saleNo = dispatchResponse.data.saleNo
						this.saleDate = dispatchResponse.data.saleDate
						// this.targetDateAuction = new Date().getTime() + parseInt(this.remainingTimeAuction) * 60 * 1000

						// console.log("patchment Response :" + JSON.stringify(patchmentResponse.data))
						// console.log("dispatch Response :" + JSON.stringify(dispatchResponse.data))
						// console.log("clean coffee Response :" + JSON.stringify(cleancoffeeResponse.data))
						// console.log("catalogue Response :" + JSON.stringify(catalogueResponse.data))
						// console.log("auction Response :" + JSON.stringify(auctionResponse.data))
						// if (fileType === 'PARCHMENT') {
						// 	this.remainingTimeParchment = response.data
						// 	this.targetDateParchment = new Date().getTime() + parseInt(this.remainingTimeParchment) * 60 * 1000
						// } else if (fileType === 'DISPATCH') {
						// 	this.remainingTimeDispatch = response.data
						// 	this.targetDateDispatch = new Date().getTime() + parseInt(this.remainingTimeDispatch) * 60 * 1000
						// } else if (fileType === 'CLEANCOFFEE') {
						// 	this.remainingTimeCleanCoffee = response.data
						// 	this.targetDateCleanCoffee = new Date().getTime() + parseInt(this.remainingTimeCleanCoffee) * 60 * 1000
						// }

						// this.targetDate = new Date().getTime() + parseInt(this.remainingTime) * 24 * 60 * 60 * 1000
					})
				)
				.catch((errors) => {
					console.log(errors)
				})
		}
	}
}
</script>
<style>
.xs3-5 {
    flex: 0 0 29.1667%;
    max-width: 29.1667%;
}
.tdate {
    font-size: 20px;
    font-weight: 700;
}

.activity {
    font-size: 18px;
    font-weight: 500;
}

.cataloguebtn {
    font-weight: 700;
    border-radius: 8px;
}

.activelink {
    background-image: linear-gradient(to right, #FFFFFF, #F2D0A7, #FFFFFF);
}

.thead {
    background-color: #00513B !important;
    color: white;
    font-size: 12px;
}

.table tbody tr>td.actions {
    font-size: 20px !important;
    color: #733D29 !important;
    /*text-align:center;
  vertical-align: middle;*/
    padding-top: 0px;
}

.pagination {
    background-color: red;
}

.paginationtext {
    color: #733D29;
}

.pagination>li>a,
.pagination>li>span {
    border: 1px solid #F2D0A7;
    color: #733D29;
}

.pagination>li.active>.page-link {
    background: #00513B;
    color: #fff;
}

.card {
    background-image: linear-gradient(233deg, #FFFFFF, #FFFFFF);
}

.activecard {
    box-shadow: 0px 0px 16px #00513B;
}

.cardnumber {
    font-size: 30px;
    font-weight: 700;
}

.cardtext {
    font-weight: 600;
    font-style: Open Sans;
}

.cardlink {
    color: #7BC243;
    font-style: Open Sans;
}

.invoicescard {
    background-image: linear-gradient(233deg, #FFFFFF, #FFFFFF);
}
</style>
